import { render } from '@testing-library/react';
import React from 'react';
import PasswordRequirements from './PasswordRequirements';

describe('PasswordRequirements', () => {
  const renderPasswordRequirements = (props) =>
    render(<PasswordRequirements {...props} />);
  const onValidate = jest.fn();
  const props = {
    password: '',
    onValidate,
  };

  describe('when password is empty', () => {
    it('renders the component', () => {
      const { container } = renderPasswordRequirements({
        ...props,
        password: '',
      });
      expect(container).toMatchSnapshot();
      expect(onValidate).toHaveBeenCalledWith(false);
    });
  });

  describe('when password contains 8 chars', () => {
    it('renders the component', () => {
      const { container } = renderPasswordRequirements({
        ...props,
        password: '12345678',
      });
      expect(container).toMatchSnapshot();
      expect(onValidate).toHaveBeenCalledWith(false);
    });
  });

  describe('when password contains upper, lower, digits and special chars', () => {
    it('renders the component', () => {
      const { container } = renderPasswordRequirements({
        ...props,
        password: 'Abc123@',
      });
      expect(container).toMatchSnapshot();
      expect(onValidate).toHaveBeenCalledWith(false);
    });
  });

  describe('when password contains 3 characters in a row', () => {
    it('renders the component', () => {
      const { container } = renderPasswordRequirements({
        ...props,
        password: 'abc123@444',
      });
      expect(container).toMatchSnapshot();
      expect(onValidate).toHaveBeenCalledWith(false);
    });
  });

  describe('when password is valid', () => {
    it('renders the component', () => {
      const { container } = renderPasswordRequirements({
        ...props,
        password: 'abc123@A',
      });
      expect(container).toMatchSnapshot();
      expect(onValidate).toHaveBeenCalledWith(true);
    });
  });
});
